import React, { useEffect, useState } from "react";
import {
  Table,
  Tooltip,
  Col,
  Row,
  Image,
  Modal,
  Upload,
} from "antd";
import HeadingBack from "../components/common/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import SvgIcon from "../components/const/SvgIcon";
import { allApiAction } from "../Redux/common/action";
import { ExclamationCircleFilled, PlusOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { URL } from "../Redux/common/url";
import { AsyncPaginate } from "react-select-async-paginate";
import Select from "react-select";
import LoadOptions from "../components/common/LoadOptions";
import api from "../Redux/common/api";
import { CKEditor } from "ckeditor4-react";

const defaultObj = {
  occasion_id: "",
  function_id: "",
  name: "",
  mobile: "",
  amount: "",
  description: "",
  image: "",
  files: "",
  type: "",
  is_feature: false,
};

const typeOptions = [
  { value: "Banquet Hall", label: "Banquet Hall" },
  { value: "Marriage Garden", label: "Marriage Garden" },
  { value: "Hotel", label: "Hotel" },
];

function Venues() {
  const { confirm } = Modal;
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [showDelelt, setShowDelete] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [venueDetails, setVenueDetails] = useState({ ...defaultObj });
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [filterData, setFilterData] = useState({
    occasion: "",
    func: "",
    city: "",
    area: "",
  });

  const token = localStorage.getItem("admin_token");

  const { venueList } = useSelector((state) => ({
    venueList: state?.allApi?.venues_list || {},
  }));

  const listData = venueList?.data ? venueList.data : [];

  useEffect(() => {
    fetchData();
  }, [search, page, filterData]);

  const fetchData = () => {
    const { occasion, func, city, area } = filterData;

    dispatch(
      allApiAction.getVenues({
        page,
        search,
        occasion_id: occasion ? occasion.value : "",
        function_id: func ? func.value : "",
        city_id: city ? city.value : "",
        area_id: area ? area.value : "",
      })
    );
  };

  const columns = [
    {
      title: "Order Id",
      dataIndex: "order_id",
    },
    {
      title: "User",
      dataIndex: "user",
    },
    {
      title: "Image",
      dataIndex: "image",
      width: "10%",
      render: (value, item) => (
        <div style={{ width: "50px" }}>
          <Image
            src={
              item?.image
                ? URL.API_BASE_URL + item.image
                : undefined
            }
            alt="N/A"
            fallback=""
          />
        </div>
      ),
    },
    {
      title: "Feature",
      dataIndex: "is_feature",
      render: (value) => (
        <span style={{ color: value ? "green" : "gray" }}>
          {value ? "On" : "Off"}
        </span>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{ __html: text || "" }}
          style={{ wordBreak: "break-word" }}
        />
      ),
    },
    {
      title: "Venue",
      dataIndex: "name",
    },

    // Added Mobile column
    {
      title: "Mobile Number",
      dataIndex: "mobile",
      key: "mobile",
      render: (mobile) => mobile || "-",
    },

    {
      title: "Occasion",
      dataIndex: "occasion",
      render: (record) => <span>{record?.title || "-"}</span>,
    },
    {
      title: "Function",
      dataIndex: "function",
      render: (record) => <span>{record?.name || "-"}</span>,
    },
    {
      title: "City",
      dataIndex: "city",
      render: (record) => <span>{record?.name || "-"}</span>,
    },
    {
      title: "Area",
      dataIndex: "area",
      render: (record) => <span>{record?.name || "-"}</span>,
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Actions",
      dataIndex: "action",
      className: "table_action_col",
      render: (value, item) => (
        <>
          <Tooltip title="Edit">
            <span
              className="cursor-pointer"
              onClick={() => handleModal(item)}
            >
              <SvgIcon.Edit className="scale-icon edit-icon" />
            </span>
          </Tooltip>

          <Tooltip title="Delete">
            <span
              className="cursor-pointer"
              onClick={() => showDeleteConfirm(item?.id)}
            >
              <SvgIcon.deletebtn className="scale-icon edit-icon" />
            </span>
          </Tooltip>
        </>
      ),
    },
  ];

  const showModalAdd = () => {
    setVenueDetails({ ...defaultObj });
    setFileList([]);
    setSelectedFile(null);
    setIsModalOpen(true);
  };

  const showDeleteConfirm = (id) => {
    confirm({
      title: "Are you sure delete?",
      icon: <ExclamationCircleFilled />,
      content: "Venue",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        handleDelete(id);
      },
    });
  };

  const handleDelete = async (id) => {
    setShowDelete(false);
    await dispatch(allApiAction.deleteVenue({ venue_id: id, page }));
    fetchData();
  };

  const handleFileChange = (event) => {
    const files = event.target.files;

    if (files?.length) {
      setSelectedFile(files);
    }
  };

  const handleTextChange = (e) => {
    const { name, value } = e.target;

    if (name === "city_id") {
      setVenueDetails((prev) => ({
        ...prev,
        city_id: value,
        area_id: "",
      }));
    } else if (name === "occasion_id") {
      setVenueDetails((prev) => ({
        ...prev,
        occasion_id: value,
        function_id: "",
      }));
    } else {
      setVenueDetails((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleModal = (editData) => {
    if (editData) {
      const {
        city,
        area,
        occasion,
        function: func,
        files,
        type,
        is_feature,
      } = editData;

      const existingImages = (files || []).map((img) => ({
        uid: img.id,
        name: img?.url?.split("/")?.pop() || "Venue image",
        status: "done",
        url: `${URL.API_BASE_URL}${img.url}`,
        id: img.id,
      }));

      setVenueDetails({
        venue_id: editData.id,
        name: editData.name || "",
        mobile: editData.mobile || "",
        amount: editData.amount ?? "",
        description: editData.description || "",

        city_id: city
          ? { value: city.id, label: city.name }
          : null,

        area_id: area
          ? { value: area.id, label: area.name }
          : null,

        occasion_id: occasion
          ? { value: occasion.id, label: occasion.title }
          : null,

        function_id: func
          ? { value: func.id, label: func.name }
          : null,

        files: existingImages,

        type:
          typeOptions.find((option) => option.value === type) || null,

        is_feature: !!is_feature,
      });

      setFileList(existingImages);
      setSelectedFile(null);
    } else {
      setVenueDetails({ ...defaultObj });
      setFileList([]);
      setSelectedFile(null);
    }

    setIsModalOpen(true);
  };

  const handlePreview = async (file) => {
    setPreviewImage(file.url || file.thumbUrl);
    setPreviewOpen(true);
  };

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const handleResetImages = () => {
    setFileList([]);
    setSelectedFile(null);
    setPreviewImage("");
  };

  const handleDeleteImage = async (imageId) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await api.post(
        `${URL.delete_venue_attachment}?id=${imageId}`,
        { id: imageId },
        config
      );

      if (response.data.status) {
        setFileList((prev) =>
          prev.filter((file) => file.id !== imageId)
        );

        toast.success(response.data.message, {
          toastId: "imageDeleted",
        });
      }
    } catch (error) {
      toast.error("Failed to delete image");
    }
  };

  const checkValidation = () => {
    if (!venueDetails?.city_id?.value) {
      toast.error("Please select City");
      return false;
    }

    if (!venueDetails?.area_id?.value) {
      toast.error("Please select Area");
      return false;
    }

    if (!venueDetails?.occasion_id?.value) {
      toast.error("Please select Occasion");
      return false;
    }

    if (!venueDetails?.function_id?.value) {
      toast.error("Please select Function");
      return false;
    }

    if (!venueDetails?.name?.trim()) {
      toast.error("Please enter a name");
      return false;
    }

    // Mobile number is optional; validate it if entered.
    if (
      venueDetails?.mobile &&
      !/^[0-9]{10}$/.test(venueDetails.mobile)
    ) {
      toast.error("Please enter a valid 10-digit mobile number");
      return false;
    }

    if (
      venueDetails?.amount === "" ||
      venueDetails?.amount === null ||
      venueDetails?.amount === undefined
    ) {
      toast.error("Please enter amount");
      return false;
    }

    if (!venueDetails?.type?.value) {
      toast.error("Please select Type");
      return false;
    }

    if (!selectedFile && !venueDetails?.venue_id) {
      toast.error("Please select image");
      return false;
    }

    if (!fileList?.length && !venueDetails?.venue_id) {
      toast.error("Please select Files");
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!checkValidation()) {
      return;
    }

    const data = new FormData();

    data.append("city_id", venueDetails?.city_id?.value);
    data.append("area_id", venueDetails?.area_id?.value);
    data.append("occasion_id", venueDetails?.occasion_id?.value);
    data.append("function_id", venueDetails?.function_id?.value);
    data.append("type", venueDetails?.type?.value);
    data.append("is_feature", venueDetails?.is_feature ? 1 : 0);

    // Added mobile to the create/update payload.
    // Send an empty string when the number is cleared.
    data.append("mobile", venueDetails?.mobile?.trim() || "");

    ["name", "amount", "description"].forEach((key) => {
      if (venueDetails?.[key] !== undefined) {
        data.append(key, venueDetails[key] ?? "");
      }
    });

    if (selectedFile) {
      for (let i = 0; i < selectedFile.length; i++) {
        data.append("image", selectedFile[i]);
      }
    }

    fileList?.forEach((file, index) => {
      if (!file?.id && file?.originFileObj) {
        data.append(`files[${index}]`, file.originFileObj);
      }
    });

    try {
      if (venueDetails?.venue_id) {
        data.append("venue_id", venueDetails.venue_id);
        await dispatch(allApiAction.updateVenue(data));
      } else {
        await dispatch(allApiAction.addVenue(data));
      }

      dispatch(allApiAction.getVenues({ page: 1 }));

      setPage(1);
      handleResetImages();
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  return (
    <div>
      <div className="flex">
        <div>
          <HeadingBack
            title="Venue"
            subHeading={`Total ${venueList?.total || 0} Venue`}
          />
        </div>

        <div className="flex flex1 align-items-center justify-content-end">
          <Tooltip title="Add">
            <span className="jop_btn" onClick={showModalAdd}>
              Add
              <SvgIcon.Add
                width={40}
                height={40}
                className="cursor-pointer"
              />
            </span>
          </Tooltip>
        </div>
      </div>

      <div className="tableResponsive mt-10">
        <Table
          rowKey="id"
          dataSource={listData}
          columns={columns}
          className="table antd_table"
          pagination={{
            current: page,
            pageSize: 10,
            onChange(current) {
              setPage(current);
            },
            hideOnSinglePage: true,
            total: venueList?.total || 0,
          }}
        />
      </div>

      <Modal
        key={isModalOpen ? "Modal Open" : "Modal Close"}
        title={venueDetails?.venue_id ? "Edit Venue" : "Add Venue"}
        open={isModalOpen}
        onOk={handleSubmit}
        onCancel={() => setIsModalOpen(false)}
        okText="Save"
      >
        <Row gutter={[20, 20]}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <label className="mb-2">
              <input
                type="checkbox"
                checked={venueDetails?.is_feature || false}
                onChange={(e) =>
                  handleTextChange({
                    target: {
                      name: "is_feature",
                      value: e.target.checked,
                    },
                  })
                }
                style={{ marginRight: "8px" }}
              />
              Feature On/Off
            </label>
          </Col>

          <Col lg={12} md={12} sm={12} xs={24}>
            <label className="mb-2">Select Type:</label>
            <Select
              options={typeOptions}
              value={venueDetails?.type || null}
              onChange={(value) =>
                setVenueDetails((prev) => ({
                  ...prev,
                  type: value,
                }))
              }
              placeholder="Select Type"
            />
          </Col>

          <Col lg={12} md={12} sm={12} xs={24}>
            <label className="mb-2">Select City:</label>
            <AsyncPaginate
              additional={{
                page: 1,
                value: "id",
                label: "name",
              }}
              value={venueDetails?.city_id || null}
              loadOptions={(search, loaded, additional) =>
                LoadOptions(
                  URL.get_cities,
                  search,
                  loaded,
                  additional
                )
              }
              onChange={(value) =>
                handleTextChange({
                  target: {
                    name: "city_id",
                    value,
                  },
                })
              }
            />
          </Col>

          <Col lg={12} md={12} sm={12} xs={24}>
            <label className="mb-2">Select Area:</label>
            <AsyncPaginate
              key={venueDetails?.city_id?.value || "city_id"}
              additional={{
                page: 1,
                value: "id",
                label: "name",
                extras: {
                  city_id: venueDetails?.city_id?.value || "",
                },
              }}
              value={venueDetails?.area_id || null}
              isDisabled={!venueDetails?.city_id?.value}
              loadOptions={(search, loaded, additional) =>
                LoadOptions(
                  URL.get_areas,
                  search,
                  loaded,
                  additional
                )
              }
              onChange={(value) =>
                handleTextChange({
                  target: {
                    name: "area_id",
                    value,
                  },
                })
              }
            />
          </Col>

          <Col lg={12} md={12} sm={12} xs={24}>
            <label className="mb-2">Select Occasion:</label>
            <AsyncPaginate
              additional={{
                page: 1,
                value: "id",
                label: "title",
              }}
              value={venueDetails?.occasion_id || null}
              loadOptions={(search, loaded, additional) =>
                LoadOptions(
                  URL.get_occasions,
                  search,
                  loaded,
                  additional
                )
              }
              onChange={(value) =>
                handleTextChange({
                  target: {
                    name: "occasion_id",
                    value,
                  },
                })
              }
            />
          </Col>

          <Col lg={12} md={12} sm={12} xs={24}>
            <label className="mb-2">Select Function:</label>
            <AsyncPaginate
              key={venueDetails?.occasion_id?.value || "occasion_id"}
              additional={{
                page: 1,
                value: "id",
                label: "name",
                extras: {
                  occasion_id:
                    venueDetails?.occasion_id?.value || "",
                },
              }}
              value={venueDetails?.function_id || null}
              isDisabled={!venueDetails?.occasion_id?.value}
              loadOptions={(search, loaded, additional) =>
                LoadOptions(
                  URL.get_functions,
                  search,
                  loaded,
                  additional
                )
              }
              onChange={(value) =>
                handleTextChange({
                  target: {
                    name: "function_id",
                    value,
                  },
                })
              }
            />
          </Col>

          <Col lg={12} md={12} sm={12} xs={24}>
            <label className="mb-2">Venue Name:</label>
            <input
              autoComplete="off"
              className="form-control"
              placeholder="Enter Venue Name"
              name="name"
              value={venueDetails?.name || ""}
              onChange={handleTextChange}
            />
          </Col>

          {/* Added Mobile Number input */}
          <Col lg={12} md={12} sm={12} xs={24}>
            <label className="mb-2">Mobile Number:</label>
            <input
              autoComplete="off"
              className="form-control"
              placeholder="Enter 10-digit mobile number"
              name="mobile"
              type="tel"
              inputMode="numeric"
              maxLength={10}
              value={venueDetails?.mobile || ""}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");

                if (value.length <= 10) {
                  handleTextChange({
                    target: {
                      name: "mobile",
                      value,
                    },
                  });
                }
              }}
            />
          </Col>

          <Col lg={12} md={12} sm={12} xs={24}>
            <label className="mb-2">Amount:</label>
            <input
              autoComplete="off"
              className="form-control"
              placeholder="Enter Amount"
              name="amount"
              value={venueDetails?.amount ?? ""}
              onChange={(e) => {
                const value = e.target.value;

                if (/^\d*\.?\d*$/.test(value)) {
                  handleTextChange({
                    target: {
                      name: "amount",
                      value,
                    },
                  });
                }
              }}
            />
          </Col>

          <Col lg={24} md={24} sm={24} xs={24} className="mt-10">
            <div className="mb-4">
              <label className="form-label">Description</label>

              <div
                className="quill-container"
                style={{ marginBottom: "50px" }}
              >
                <CKEditor
                  initData={venueDetails?.description || ""}
                  config={{
                    extraPlugins: "table",
                    removePlugins: "elementspath",
                    resize_enabled: false,
                    toolbarGroups: [
                      {
                        name: "basicstyles",
                        groups: ["basicstyles", "cleanup"],
                      },
                      {
                        name: "paragraph",
                        groups: [
                          "list",
                          "indent",
                          "blocks",
                          "align",
                        ],
                      },
                      { name: "insert" },
                      { name: "styles" },
                      { name: "colors" },
                      { name: "links" },
                      { name: "table" },
                    ],
                    table_removeTableTag: false,
                  }}
                  onChange={(event) => {
                    const data = event.editor.getData();

                    setVenueDetails((prev) => ({
                      ...prev,
                      description: data,
                    }));
                  }}
                />
              </div>
            </div>
          </Col>

          <Col lg={12} md={12} sm={12} xs={24}>
            <label className="mb-2">Image:</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
            />
          </Col>

          <Col lg={24} md={24} sm={24} xs={24}>
            <label className="mb-2">Files:</label>

            <Upload
              listType="picture-card"
              fileList={fileList}
              onPreview={handlePreview}
              onRemove={(file) =>
                file?.id ? handleDeleteImage(file.id) : true
              }
              onChange={handleChange}
              multiple
              beforeUpload={() => false}
            >
              {fileList.length >= 20 ? null : (
                <div>
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>Upload</div>
                </div>
              )}
            </Upload>
          </Col>

          {previewImage && (
            <Image
              wrapperStyle={{ display: "none" }}
              preview={{
                visible: previewOpen,
                onVisibleChange: (visible) =>
                  setPreviewOpen(visible),
                afterOpenChange: (visible) =>
                  !visible && setPreviewImage(""),
              }}
              src={previewImage}
            />
          )}
        </Row>
      </Modal>
    </div>
  );
}

export default Venues;
